import faxDocumentTypes from './../fax-document-types';
import faxStatuses from './../fax-statuses';
import {indexedFaxStatuses} from './../fax-statuses';
import appCONST from 'constants/app.constants';

export default function AdminFaxSearchService(
    $http,
    userService
) {
    'ngInject';

    const MIN_DATE = '2017-01-01';
    const faxListEndpoint = '/management/fax';
    const resendFaxEndpoint = '/management/fax/resend';
    const SHOW_ALL = 'showAll';
    const DATE_FORMAT = 'MM/DD/YYYY';

    return {
        getDefaultFaxDocumentTypes,
        getDefaultFaxStatuses,
        getFromDateOptions,
        getArrivalDateOptions,
        getToDateOptions,
        getFaxes,
        processParams,
        resendFaxes,
    };

    function getFaxes(params = {}) {
        const url = `${appCONST.apiUrl}${faxListEndpoint}`;
        return $http.get(url, {params})
            .then(processFaxResults)
            .then(({data}) => data);
    }

    function processParams(params) {
        const {dateFormat} = userService.getRegionalSettings();
        const newParams = angular.copy(params);

        const {sentDates: {from, to}, arrivalDate} = newParams;
        newParams.sentDateFrom = from ? moment(from, dateFormat).format(DATE_FORMAT) : null;
        newParams.sentDateTo = to ? moment(to, dateFormat).format(DATE_FORMAT) : null;
        newParams.arrivalDate = arrivalDate ? moment(arrivalDate, dateFormat).format(DATE_FORMAT) : null;

        if (newParams.faxStatus && newParams.faxStatus.includes(SHOW_ALL)) {
            newParams.faxStatus = undefined;
        }

        if (newParams.documentType && newParams.documentType.includes(SHOW_ALL)) {
            newParams.documentType = undefined;
        }

        return newParams;
    }

    function processFaxResults(faxResults) {
        faxResults.data.hotelFaxList
            .forEach((fax) => fax.statusLabel = angular.isNumber(fax.status)
                ? indexedFaxStatuses[fax.status].label
                : '');
        return faxResults;
    }

    function resendFaxes(hotelFaxIds) {
        const url = `${appCONST.apiUrl}${resendFaxEndpoint}`;
        return $http.post(url, {hotelFaxIds})
            .then(({data}) => data);
    }

    function getDefaultFaxDocumentTypes() {
        return faxDocumentTypes;
    }

    function getDefaultFaxStatuses() {
        return faxStatuses;
    }

    function getFromDateOptions() {
        return {
            placeholder: 'From',
            months: 1,
            start: moment(),
            after: moment(MIN_DATE).add({days: -1}),
        };
    }

    function getArrivalDateOptions() {
        return {
            placeholder: 'Arrival',
            months: 1,
            start: moment(),
            after: moment(MIN_DATE).add({days: -1}),
        };
    }

    function getToDateOptions() {
        return {
            placeholder: 'To',
            months: 1,
            start: moment(),
            after: moment(MIN_DATE).add({days: -1}),
            before: moment(),
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/admin/admin-fax/admin-fax-search/admin-fax-search-service.js